import GameDetailsInline from '~/client/shared/game/GameDetailsInline';
import Column from './Column';

const LiveRtpDetails: FC<LiveRtpDetailsProps> = ({ game }) => (
  <GameDetailsInline className="grid-cols-3">
    <Column
      rtp={game?.rtp}
      rtpLive={game?.rtpLivePastDay}
      translateId="casino.rtp_24h"
      highlight
    />
    <Column
      rtp={game?.rtp}
      rtpLive={game?.rtpLivePastSevenDays}
      translateId="casino.rtp_week"
    />
    <Column
      rtp={game?.rtp}
      rtpLive={game?.rtpLivePastThirtyDays}
      translateId="casino.rtp_month"
    />
  </GameDetailsInline>
);

export default LiveRtpDetails;
